import React from 'react';
import PropTypes from 'prop-types';

import {Box, Button, Stack} from 'views/components';
import {ArrowForwardIos} from 'views/icons';
import {WasHelpfulCard, Translate} from 'views/module';

import {primaryButtonSx} from '../../utils/button_styles';

import NextStepsSection from './cards/NextStepsSection';
import WhatHappensCard from './cards/WhatHappensCard';
import WorksCard from './cards/WorksCard';

const CaregiverMatchingStep = (props) => {
  const {onNext} = props;

  return (
    <Stack sx={{gap: '8px'}}>
      <NextStepsSection />
      <WhatHappensCard />
      <WorksCard />
      <WasHelpfulCard articleTitle="Intake Form | Caregiver Matching | Feedback (Thumbs)" articleRN="RN:ARTICLE-V1-CaregiverMatchingHelpful" />

      <Box sx={{textAlign: 'right', mt: '24px'}}>
        <Button onClick={onNext} sx={primaryButtonSx} endIcon={<ArrowForwardIos />}>
          <Translate expression={'caregivermatchingstep.CaregiverMatchingStep.RequestProfilesButton'} />
        </Button>
      </Box>
    </Stack>
  );
};

CaregiverMatchingStep.propTypes = {
  onNext: PropTypes.func,
};

export default React.memo(CaregiverMatchingStep);
